import { render } from "./otpInput.vue?vue&type=template&id=265ec93d&scoped=true"
import script from "./otpInput.vue?vue&type=script&lang=js"
export * from "./otpInput.vue?vue&type=script&lang=js"

import "./otpInput.vue?vue&type=style&index=0&id=265ec93d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265ec93d"]])

export default __exports__